import "./style.css"
import React, { useState, useEffect, useRef } from "react";
import FrontLayout from "../../../components/layout-new-theme/FrontLayout";
import { useTranslation } from "react-i18next";
import {
    verifyToken,
    saveNewPassword
} from "../../../actions/profile";
import InputForm from "../../../components/input/input-register/InputForm";
import { useLoading } from "../../../components/LoadingContext";
import { useParams, useHistory } from "react-router-dom";
import { validateForm } from "./validator";

const ChangePassword = () => {
    const { t } = useTranslation();
    const { token } = useParams();
    const history = useHistory();
    const { showLoading, closeLoading } = useLoading();
    const [errorsFormData, setErrorsFormData] = useState({});
    const [isVisible, setIsVisible] = useState(false);
    const [formData, setFormData] = useState({
        newPassword: "",
        confirmNewPassword: ""
    })
    const formRefs = {
        newPasswordRef: useRef(),
        confirmNewPasswordRef: useRef()
    }
    const firstErrorRef = useRef(null);

    const verifyTokenHandler = async (token) => {
        showLoading(true);
        const tokenVerification = await verifyToken({ token });
        closeLoading(true);

        if (tokenVerification.code !== 200 || tokenVerification.desc !== "SUCCESS") {
            history.replace('/my-page/account')
        }

    }

    useEffect(() => {
        verifyTokenHandler(token);
    }, [token])

    const formValidation = async () => {
        const { validationSuccess, firstError, validationMessage } = await validateForm(formData);

        firstErrorRef.current = null;
        if (!validationSuccess) {
            setErrorsFormData(validationMessage);

            firstErrorRef.current = formRefs[firstError + "Ref"].current;

            if (firstErrorRef.current) {
                firstErrorRef.current.scrollIntoView({ block: "center" });
            }
        }

        return validationSuccess;
    };

    const handleClickSavePassword = async () => {
        const validationFormData = await formValidation(formData);

        if (validationFormData) {
            showLoading(true)
            const savePassword = await saveNewPassword({
                ...formData,
                token
            })

            if (savePassword.desc === "SUCCESS" && savePassword.code === 200) {
                closeLoading(true)
                history.push('/my-page/account', {
                    modal: "changePassword"
                });
            } else {
                closeLoading(true)
            }
        }
    }

    return (
        <FrontLayout>
            <div className="bg-my-page">
                <div className="tw:w-full tw:mx-auto tw:[--gx:1.5rem] tw:mt-1 tw:pt-1 tw:px-0 tw:lg:px-2">
                    <div className="custom-mx">
                        <div className="tw:w-full tw:mx-auto tw:[--gx:1.5rem] tw:sm:max-w-[540px] tw:md:max-w-[720px] tw:lg:max-w-[960px] tw:xl:max-w-[1140px] tw:2xl:max-w-[1320px] tw:pb-12 tw:!mt-8 tw:lg:w-full tw:lg:flex-none tw:px-0 tw:lg:px-2">
                            <div className="tw:px-6 tw:lg:px-0 tw:pb-2">
                                <h2>{t('changePassword.title')}</h2>
                            </div>
                            <div className="tw:relative tw:flex tw:flex-col tw:min-w-0 tw:bg-white tw:bg-clip-border tw:border tw:border-[rgba(0,0,0,0.125)] tw:rounded-[0.3rem] card-layout-myPage tw:mb-6">
                                <div className="tw:flex-1 tw:p-4 tw:p-0 tw:m-0">
                                    <div>
                                        <div className="tw:relative tw:flex tw:flex-col tw:min-w-0 tw:bg-white tw:bg-clip-border tw:border tw:border-[rgba(0,0,0,0.125)] tw:rounded-[0.3rem] card-myPage tw:my-2">
                                            <div className="tw:flex-1 tw:p-4 tw:px-6">
                                                <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)] tw:items-start tw:justify-between">
                                                    <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:mb-4">
                                                        <InputForm
                                                            innerRef={formRefs.newPasswordRef}
                                                            type={isVisible ? "text" : "password"}
                                                            suffixClass={"mb-0 fs-14"}
                                                            label={t("changePassword.form.newPassword")}
                                                            placeholder={t("changePassword.form.newPassword")}
                                                            id={"newPassword"}
                                                            name={"newPassword"}
                                                            value={formData.newPassword}
                                                            onChange={(e) => {
                                                                setErrorsFormData({ ...errorsFormData, newPassword: "" })
                                                                setFormData({ ...formData, newPassword: e.target.value })
                                                            }}
                                                            isInvalid={errorsFormData.newPassword}
                                                            invalidMessage={t(errorsFormData.newPassword)}
                                                        />
                                                    </div>
                                                    <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none">
                                                        <InputForm
                                                            innerRef={formRefs.confirmNewPasswordRef}
                                                            type={isVisible ? "text" : "password"}
                                                            suffixClass={"mb-0 fs-14"}
                                                            label={t("changePassword.form.confirmNewPassword")}
                                                            placeholder={t("changePassword.form.confirmNewPassword")}
                                                            id={"confirmNewPassword"}
                                                            name={"confirmNewPassword"}
                                                            value={formData.confirmNewPassword}
                                                            onChange={(e) => {
                                                                setErrorsFormData({ ...errorsFormData, confirmNewPassword: "" })
                                                                setFormData({ ...formData, confirmNewPassword: e.target.value })
                                                            }}
                                                            isInvalid={errorsFormData.confirmNewPassword}
                                                            invalidMessage={t(errorsFormData.confirmNewPassword)}
                                                        // suffixIcon={check_green}
                                                        // suffixOnClick={() => setIsVisible(!isVisible)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="tw:flex tw:items-center tw:justify-center tw:gap-2">
                                <button
                                    className="tw:inline-block tw:font-normal tw:leading-normal tw:text-center tw:no-underline tw:align-middle tw:cursor-pointer tw:select-none tw:border tw:border-transparent tw:px-3 tw:py-[0.375rem] tw:text-base tw:rounded-[0.25rem] tw:transition-[color,background-color,border-color,box-shadow] tw:duration-150 tw:disabled:opacity-65 tw:disabled:pointer-events-none btn-save-change-email tw:flex tw:items-center tw:justify-center"
                                    onClick={() => handleClickSavePassword()}
                                >
                                    <p className="tw:text-center tw:my-0">
                                        {t("changePassword.button")}
                                    </p>
                                </button>
                                <button
                                    className="tw:inline-block tw:font-normal tw:leading-normal tw:text-center tw:no-underline tw:align-middle tw:cursor-pointer tw:select-none tw:border tw:border-transparent tw:px-3 tw:py-[0.375rem] tw:text-base tw:rounded-[0.25rem] tw:transition-[color,background-color,border-color,box-shadow] tw:duration-150 tw:disabled:opacity-65 tw:disabled:pointer-events-none btn-discard-change-email tw:flex tw:items-center tw:justify-center"
                                    onClick={() => history.push("/my-page/account")}
                                >
                                    <p className="tw:text-center tw:my-0">
                                        {t("changePassword.buttonDiscard")}
                                    </p>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </FrontLayout>
    );
};

export default ChangePassword;
